export function selectedOptionValues(value: string): Array<string> {
  if (!value || value === 'All') {
    return [];
  }
  return value
    .split(',')
    .map((part) => part.trim())
    .filter((part) => part.length > 0);
}

export function toggleOptionValue(
  value: string,
  option: string,
  availableOptions: Array<string> = [],
): string {
  const selected = new Set(selectedOptionValues(value));
  if (selected.has(option)) {
    selected.delete(option);
  } else {
    selected.add(option);
  }
  const uniqueAvailableOptions = new Set(availableOptions);
  const hasSelectedEveryOption =
    uniqueAvailableOptions.size > 0 &&
    selected.size === uniqueAvailableOptions.size &&
    [...uniqueAvailableOptions].every((item) => selected.has(item));
  if (hasSelectedEveryOption) {
    return 'All';
  }
  const next = [...selected];
  return next.length > 0 ? next.join(',') : 'All';
}

const OPAQUE_ID = /^[a-f0-9]{24}$/i;

function isOpaqueId(value: string): boolean {
  return OPAQUE_ID.test(value);
}

function labelForOption(
  item: string,
  options: Array<{ value: string; label: string }>,
): string | null {
  const match = options.find((option) => option.value === item)?.label;
  if (match) {
    return match;
  }
  if (isOpaqueId(item)) {
    return null;
  }
  return item;
}

export function optionFilterLabel(
  value: string,
  options: Array<{ value: string; label: string }>,
  allLabel: string,
): string {
  const selected = selectedOptionValues(value);
  if (selected.length === 0) {
    return allLabel;
  }
  const labels = selected
    .map((item) => labelForOption(item, options))
    .filter((label): label is string => Boolean(label));
  if (labels.length === 0) {
    return selected.length === 1 ? '1 selected' : `${selected.length} selected`;
  }
  return labels.join(', ');
}

export function activeFilterChipLabel(
  value: string,
  options: Array<{ value: string; label: string }>,
): string | null {
  if (!value || value === 'All') {
    return null;
  }
  return optionFilterLabel(value, options, value);
}

export function filterOptionChoices(
  options: Array<{ value: string; label: string }>,
  query: string,
): Array<{ value: string; label: string }> {
  const normalizedQuery = query.trim().toLowerCase();
  if (!normalizedQuery) return options;

  return options.filter((option) =>
    option.label.toLowerCase().includes(normalizedQuery),
  );
}
